import { render } from "./fb5.vue?vue&type=template&id=ac18fd2a&scoped=true"
import script from "./fb5.vue?vue&type=script&lang=js"
export * from "./fb5.vue?vue&type=script&lang=js"

import "./fb5.vue?vue&type=style&index=0&id=ac18fd2a&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac18fd2a"]])

export default __exports__